import { AxiosResponse } from "axios";
import { api, CustomAxiosRequestConfig } from "../api";
const baseQRUrl = process.env.REACT_APP_2D_CODE_API_URL;
const getQRUrl = `${baseQRUrl}api/redirect-qr`;
const generatePdfUrl = `${baseQRUrl}api/redirect-qr/pdf`;
const generateBulkPdfUrl = `${baseQRUrl}api/redirect-qr/pdf/bulk`;
export const apiMachineQR = (
  modelType: string | undefined,
  serialNumber: string | undefined,
): Promise<AxiosResponse> => {
  return api.post(
    getQRUrl,
    {
      modelType: modelType,
      serialNumber: serialNumber,
    },
    { skipGlobalLoader: true } as CustomAxiosRequestConfig,
  );
};

export const apiGenerateQRPdf = (
  modelType: string,
  serialNumber: string,
  qrImageUrl: string,
  filename: string,
  customerMachineNumber: string,
): Promise<AxiosResponse<Blob>> => {
  return api.post(
    `${generatePdfUrl}?filename=${encodeURIComponent(filename)}`,
    {
      modelType,
      serialNumber,
      qrImageSrc: qrImageUrl,
      customerMachineNumber,
    },
    {
      responseType: "blob",
    },
  );
};

export const apiGenerateBulkQRPdf = (
  machines: { modelType: string; serialNumber: string }[],
  filename: string,
): Promise<AxiosResponse<Blob>> => {
  return api.post(
    `${generateBulkPdfUrl}?filename=${encodeURIComponent(filename)}`,
    { machines },
    {
      responseType: "blob",
    },
  );
};
